interface IProps {
  loanSelected: any;
}

export const BoxClosing: React.FC<IProps> = ({ loanSelected }: IProps) => {

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const offset = date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() + offset);

    const optionsMonthYear = { year: 'numeric', month: 'short' };
    // @ts-ignore
    const monthYear = date.toLocaleDateString('en-US', optionsMonthYear);

    const optionsDay = { day: 'numeric' };
    // @ts-ignore
    const day = date.toLocaleDateString('en-US', optionsDay);

    return { monthYear, day };
  };
  const closingDate = loanSelected?.salesforceData?.closingDate ? formatDate(loanSelected?.salesforceData?.closingDate): null;
  const closingScheduled = loanSelected?.salesforceData?.closingScheduled;

  return (
    <div className='closing'>
      {
        closingDate ?
          <>
            {
              closingScheduled ?
                <div className='label'>Sch. closing</div>
                :
                <div className='label'>Est. closing</div>
            }
            <div className='calendar'>
              <div className='date'>
                {closingDate.monthYear}
              </div>
              <div className='day'>
                {closingDate.day}
              </div>
            </div>
            {
              closingScheduled ?
                <div className='caption'>Closing <b>IS</b> scheduled</div>
                :
                <div className='caption'>Closing <b>NOT</b> scheduled</div>
            }
          </>
          :
          <>
            <div className='label'>Est. closing</div>
            <div className='calendar disabled'>
              <div className='date'>
                PENDING
              </div>
              <div className='day'>
                00
              </div>
            </div>
            <div className='caption'>Closing <b>NOT</b> scheduled</div>
          </>
      }
    </div>
  )
}